import { AuthProviderProps } from 'react-oidc-context';
import { BrowserCultureInfo } from '@bimone/bimtrack-core';

interface BimTrackConfigurationData {
  bimTrackApiBaseUrl: string;
  authenticationServerBaseUrl: string;
  authenticationClientId: string;
  scopes: string;
}

export default class BimTrackConfiguration {
  private static currentConfiguration: BimTrackConfigurationData = {
    bimTrackApiBaseUrl: '',
    authenticationServerBaseUrl: '',
    authenticationClientId: '',
    scopes: '',
  };

  public static setConfiguration(configuration: unknown): void {
    const bimTrackConfiguration = configuration as BimTrackConfigurationData;

    BimTrackConfiguration.currentConfiguration = {
      bimTrackApiBaseUrl: bimTrackConfiguration.bimTrackApiBaseUrl,
      authenticationServerBaseUrl: bimTrackConfiguration.authenticationServerBaseUrl,
      authenticationClientId: bimTrackConfiguration.authenticationClientId,
      scopes: bimTrackConfiguration.scopes,
    };
  }

  public static getBimTrackApiBaseUrl(): string {
    return BimTrackConfiguration.currentConfiguration.bimTrackApiBaseUrl;
  }

  public static getOIDCConfiguration(): AuthProviderProps {
    return {
      authority: BimTrackConfiguration.currentConfiguration.authenticationServerBaseUrl,
      client_id: BimTrackConfiguration.currentConfiguration.authenticationClientId,
      redirect_uri: `${this.getCurrentWebAppLocation()}/redirect`,
      post_logout_redirect_uri: this.getCurrentWebAppLocation(),
      scope: BimTrackConfiguration.currentConfiguration.scopes,
      loadUserInfo: true,
      ui_locales: BrowserCultureInfo.getPreferredLanguage(),
    };
  }

  public static getCurrentWebAppLocation(): string {
    if (window) {
      const baseUrl = `${window.location.protocol}//${window.location.hostname}`;

      if (window.location.port) {
        return `${baseUrl}:${window.location.port}`;
      }

      return baseUrl;
    }

    return '';
  }
}
